export const TRANSLATIONS = {
  en: {
    app_name: "RFQ Hub",
    email: "Email",
    password: "Password",
    signing_in: "Signing in...",
    sign_in: "Sign In",
    sign_in_google: "Sign in with Google",
    or: "or",
    verifying_connection: "Verifying your connection...",
    security_check: "Security check by Cloudflare",
    verification_failed: "Verification failed",
    please_try_again: "Please try again",
    try_again: "Try again",
    locked: "Locked",
    unlock_account: "Unlock account",
    account_unlocked: "Account unlocked",
    hi: "Hi",
    different_user: "Different user",
    passkeys: "Passkeys",
    add_passkey: "Add Passkey",
    passkey_desc: "Use fingerprint, Face ID, or security key to sign in without a password.",
    no_passkeys: "No passkeys registered yet",
    passkey_added: "Passkey added successfully",
    passkey_deleted: "Passkey removed",
    passkey_cancelled: "Authentication was cancelled",
    sign_in_passkey: "Sign in with Passkey",
    added: "Added",
    default_credentials: "Default: admin@rfq.inception.sa / Admin@123",
    // Forgot/Reset password
    forgot_password: "Forgot Password?",
    forgot_password_desc: "Enter your email and we'll send you a reset link.",
    send_reset_link: "Send Reset Link",
    reset_email_sent: "If the email is registered, a reset link has been sent. Check your inbox.",
    back_to_login: "Back to Sign In",
    reset_password: "Reset Password",
    reset_password_desc: "Choose a new password for your account.",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    passwords_mismatch: "Passwords do not match",
    password_too_short: "Password must be at least 4 characters",
    password_reset_success: "Password reset successful. You can now sign in.",
    // Invite
    accept_invite: "Accept Invitation",
    accept_invite_desc: "Set a password to create your account.",
    create_account: "Create Account",
    account_created: "Account created successfully. You can now sign in.",
    click_here_to_login: "Click here to login",
    invite_user: "Invite User",
    invite_email: "Email",
    invite_name: "Full Name",
    invite_role: "Role",
    invite_sent: "Invitation sent",
    invite_sending: "Sending...",
    finance_manager_role: "Finance Manager",
    edit_user: "Edit",
    save_changes: "Save",
    user_updated: "User updated",
    active: "Active",
    inactive: "Inactive",
    deactivated_account: "This account is deactivated",
    tab_personal_info: "Personal Info",
    tab_security: "Security",
    tab_delegation: "Delegation",
    tab_passkeys: "Passkeys",
    change_photo: "Change photo",
    remove_photo: "Remove photo",
    avatar_specs: "Max 5MB · JPEG, PNG or WEBP",
    avatar_invalid_type: "Only JPEG, PNG or WEBP images are allowed",
    avatar_too_large: "Image must be under 5MB",
    avatar_uploaded: "Profile picture updated",
    avatar_removed: "Profile picture removed",
    admin_only: "Admin only",
    session_expired: "Your session has expired. Please sign in again.",
    session_timeout: "Auto Logout",
    dark_mode: "Dark Mode",
    light_mode: "Light Mode",
    auto_mode: "Automatic",
    theme_mode: "Theme Mode",
    this_month: "this month",
    total_rfqs: "Total RFQs",
    company_analytics: "Company Analytics",
    analytics: "Analytics",
    revenue_financial: "Revenue & Financial",
    total_revenue: "Total Revenue",
    paid_revenue: "Paid Revenue",
    total_profit: "Total Profit",
    avg_deal_size: "Avg Deal Size",
    profit_margin: "Profit Margin",
    revenue_over_time: "Revenue Over Time",
    top_clients_revenue: "Top Clients by Revenue",
    top_am_revenue: "Top AMs by Revenue",
    profit_by_am: "Profit by AM",
    profit_by_client: "Profit by Client",
    avg_deal_trend: "Average Deal Size Trend",
    overview: "Overview",
    by_client: "By Client",
    by_am: "By AM",
    deal_size: "Deal Size",
    rfq_pipeline: "RFQ Pipeline",
    status_distribution: "Distribution",
    conversion_funnel: "Funnel",
    monthly_volume: "Volume",
    time_to_close: "Timing",
    avg_time_close: "Avg Time to Close",
    days_created_to_quot_sent: "Days from created to Quot Sent",
    close_time_trend: "Close Time Trend (days)",
    am_performance: "Account Manager Performance",
    rfqs_per_am: "RFQs per AM",
    am_win_rate: "Win Rate",
    rfqs_count: "RFQs",
    win_rate: "Win Rate",
    approved_vs_rejected: "Approved vs Rejected",
    am_ranking: "AM Ranking",
    revenue_by_am: "Revenue & Profit by AM",
    am_revenue_ranking: "Revenue Ranking",
    client_insights: "Client Insights",
    total_clients: "Total Clients",
    repeat_clients: "Repeat Clients",
    new_clients: "New Clients",
    repeat_rate: "Repeat Rate",
    single_rfq: "Single RFQ",
    top_clients_volume: "Top Clients by Volume",
    by_revenue: "By Revenue",
    by_volume: "By Volume",
    client_revenue_chart: "Client Revenue",
    client_volume_chart: "Client Volume",
    full_ranking: "Full Ranking",
    health_score: "Health",
    health_excellent: "Excellent",
    health_good: "Good",
    health_fair: "Fair",
    health_at_risk: "At Risk",
    rfqs_short: "RFQs",
    avg_pay: "avg pay",
    avg_pay_days: "Avg Pay",
    score: "Score",
    repeat: "Repeat",
    payment: "Payment",
    trend: "Trend",
    client: "Client",
    rfqs_in_period: "RFQs in period",
    margin: "margin",
    all_created: "Created",
    invoiced_revenue: "Invoiced Revenue",
    top_clients: "Top Clients",
    top_ams: "Top AMs",
    recent_activity: "Recent Activity",
    export_csv: "Export CSV",
    total_cost: "Cost",
    profit: "Profit",
    session_timeout_desc: "Logout users after inactive for",
    am_analytics: "AM Analytics",
    am_analytics_desc: "Show analytics cards on Account Manager dashboard",
    email_notifications: "Email Notifications",
    email_notifications_desc: "Master toggle for all email notifications",
    notify_per_status: "Notify on each status",
    new_quotation: "New RFQ",
    quotations: "RFQs",
    admin: "Settings",
    sign_out: "Sign out",
    dashboard_title: "RFQs",
    dashboard_subtitle: "Manage your RFQs",
    total: "Total",
    draft: "Draft",
    submitted: "Submitted",
    resubmitted: "Resubmitted",
    approved: "Approved",
    quot_sent: "Quot Sent",
    progress_finalized: "Closed",
    submitted_by: "Submitted By",
    rejected: "Rejected",
    returned: "Returned",
    reject_confirm: "Are you sure you want to reject this RFQ?",
    reject_by_client_confirm: "Reject this RFQ? It will be noted as rejected by client / account manager.",
    rejected_by_client: "Rejected by Client / Account Manager",
    reject_modal_title: "Reject RFQ",
    reject_reason_label: "Rejection Reason",
    reject_reason_placeholder: "Why is this RFQ being rejected? e.g. Client declined, pricing issue...",
    reject_confirm_btn: "Reject RFQ",
    cancel_modal_title: "Cancel RFQ",
    cancel_reason_label: "Reason for Cancellation",
    cancel_reason_placeholder: "Why is this RFQ being canceled? e.g. Client request, duplicate entry...",
    cancel_confirm_btn: "Cancel RFQ",
    archived: "Archived",
    all: "All",
    search_placeholder: "Search for anything...",
    date_filter: "Date",
    date_all: "All time",
    date_today: "Today",
    date_7days: "Last 7 days",
    date_30days: "Last 30 days",
    date_3months: "Last 3 months",
    quote_number: "RFQ #",
    client: "Client",
    project: "Project",
    status: "Status",
    amount: "Amount",
    empty_state: "No RFQs found",
    create_first: "Create your first RFQ",
    new_quotation_title: "New RFQ",
    quotation_details: "RFQ Details",
    client_name: "Client Name",
    client_placeholder: "Client company or name",
    create_new_client: "Create new client",
    no_clients_yet: "No clients yet — type a name to create one",
    project_name: "Project Name",
    project_placeholder: "Project description",
    items_section: "Items",
    item_details: "Item Details",
    new_item: "New Item",
    item_name: "Item Name",
    item_placeholder: "e.g. Web Design Services",
    description: "Description",
    desc_placeholder: "Optional details...",
    qty: "Qty",
    selling_price_sar: "Selling Price (SAR)",
    third_party: "Third-party supplier",
    supplier_cost: "Supplier Cost (SAR)",
    margin_pct: "Margin %",
    calc_price: "Calculated Price (SAR)",
    override_price: "Override Price",
    override_price_sar: "Override Price (SAR)",
    line_total: "Line Total",
    item_total: "Item Total",
    add_item_btn: "Add Item",
    cancel: "Cancel",
    send: "Send",
    add_more: "Add More Item",
    no_items_yet: "No items added yet.",
    no_items: "No items",
    notes_label: "Notes",
    notes_placeholder: "Any additional notes or terms...",
    subtotal_excl_vat: "Subtotal excl. VAT",
    save_draft: "Save Draft",
    submit_review: "Submit to Finance",
    export_pdf: "Export PDF",
    back: "Back",
    pending_review_title: "Awaiting Admin Approval",
    pending_review_desc: "This RFQ has been submitted and is pending review by an admin.",
    review_quotation: "Finance Team Review:",
    approve: "Approve",
    reject: "Return",
    edit_quotation: "Edit RFQ",
    edit_warning: "Editing will reset this RFQ back to Draft.",
    admin_panel: "Settings",
    admin_subtitle: "Manage users, items, roles and application settings",
    users_tab: "Users",
    settings_tab: "Settings",
    add_user: "Add User",
    create_user_title: "Create New User",
    name: "Name",
    name_placeholder: "Full name",
    email_placeholder: "email@example.com",
    password_placeholder: "Password",
    role: "Role",
    account_manager_role: "Account Manager",
    admin_role: "Admin",
    create_user_btn: "Create User",
    no_users: "No users",
    delete: "Delete",
    delete_rfq: "Delete",
    delete_confirm: "Are you sure you want to delete this RFQ?",
    rfq_deleted: "RFQ deleted",
    archive: "Archive",
    archive_confirm: "Archive this returned RFQ?",
    rfq_archived: "RFQ archived",
    quotation_settings: "RFQ Settings",
    default_margin: "Default Margin %",
    default_margin_desc: "Applied to new supplier items by default",
    allow_override: "Allow Selling Price Override",
    allow_override_desc: "Account managers can manually override calculated price for supplier items",
    change_password_title: "Change User Password",
    select_user: "Select user...",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    change_password_btn: "Change Password",
    passwords_no_match: "Passwords do not match",
    supplier_label: "Supplier",
    third_party_label: "3rd Party",
    supplier_cost_label: "Cost",
    quotation_saved: "RFQ saved",
    quotation_updated: "RFQ updated",
    status_updated: "Status updated",
    user_created: "User created successfully",
    user_deleted: "User deleted",
    settings_saved: "Settings saved",
    password_changed: "Password changed successfully",
    client_required: "Client name is required",
    project_required: "Project name is required",
    item_name_required: "Item name is required",
    qty_required: "Qty must be > 0",
    price_required: "Required",
    all_fields_required: "All fields are required",
    invalid_role: "Invalid role",
    issue_date: "Issue Date",
    profile: "Profile",
    profile_title: "My Profile",
    profile_subtitle: "Manage your account settings",
    profile_saved: "Profile saved",
    mobile: "Mobile",
    mobile_placeholder: "+966 5x xxx xxxx",
    profile_picture: "Profile Picture",
    profile_picture_placeholder: "Paste image URL",
    admin_only: "Admin only",
    badge_color: "Badge Color",
    reset: "Reset",
    change_my_password: "Change My Password",
    current_password: "Current Password",
    password_min_length: "Password must be at least 6 characters",
    duplicate_quotation: "Duplicate",
    quotation_duplicated: "RFQ duplicated",
    generating_pdf: "Generating PDF...",
    services_tab: "Services",
    add_service: "Add Service",
    edit_service: "Edit Service",
    service_name: "Service Name",
    service_name_placeholder: "e.g. Web Design",
    service_description: "Description",
    service_desc_placeholder: "Service details...",
    service_price: "Default Price (SAR)",
    save_service: "Save",
    no_services: "No services added yet",
    service_created: "Service created",
    service_updated: "Service updated",
    service_deleted: "Service deleted",
    item_type: "Item Type",
    item_type_internal: "Internal",
    item_type_third_party: "3rd Party",
    supplier_price_label: "Supplier Price (SAR)",
    margin_label: "Margin %",
    final_price_label: "Final Price (SAR)",
    click_to_edit: "Click to edit",
    hide_statuses: "Custom Filter",
    reassign_rfqs: "Reassign RFQs",
    reassign_desc: "Move all RFQs from this user to another user.",
    reassign_before_action: "Select a user to move all RFQs to before proceeding.",
    move_rfqs_to: "Move RFQs to",
    select_user: "Select user...",
    skip_reassign: "Skip (no move)",
    reassign: "Reassign",
    move_and_delete: "Move & Delete",
    move_and_deactivate: "Move & Deactivate",
    rfqs_reassigned: "RFQs reassigned successfully",
    moved_from: "Moved from",
    delete_user_title: "Delete User",
    deactivate_user_title: "Deactivate User",
    vendor_party_price: "3rd Party/Vendor Price",
    our_final_price: "Our Final Price (click to edit)",
    auto: "auto",
    select_item_type: "Choose item type to add",
    internal_desc: "In-house service or product",
    third_party_desc: "Sourced from an external supplier",
    select_from_catalog: "From Catalog",
    revision_history: "Revision History",
    no_history: "No revision history",
    history_by: "by",
    trash: "Trash",
    trash_title: "Trash",
    trash_subtitle: "Deleted RFQs",
    restore: "Restore",
    rfq_restored: "RFQ restored",
    delete_permanent: "Delete Forever",
    delete_permanent_confirm: "Permanently delete this RFQ? This cannot be undone.",
    rfq_permanently_deleted: "RFQ permanently deleted",
    empty_trash: "Trash is empty",
    // Clients
    clients: "Clients",
    clients_subtitle: "Manage client directory",
    clients_lower: "clients",
    add_client: "Add Client",
    edit_client: "Edit Client",
    client_name_label: "Client Name",
    legal_name: "Legal Name",
    legal_name_placeholder: "Official legal name",
    no_clients: "No clients yet",
    client_saved: "Client saved",
    client_deleted: "Client deleted",
    // Finance
    finance_quote_no: "Quotation No",
    finance_quote_no_placeholder: "Enter finance quotation number",
    invoice_number: "Invoice Number",
    invoice_number_placeholder: "Enter invoice number",
    invoice_status: "Invoice Status",
    invoiced: "Invoiced",
    paid: "Paid",
    partially_paid: "Partially Paid",
    mark_as_paid: "Mark as Paid",
    full_paid: "Full Paid",
    not_invoiced: "Not Invoiced",
    notif_invoice_requested: "Invoice Requested",
    notif_invoice_available: "Invoice Available",
    notif_quotation_available: "Quotation Available",
    notif_desc_submitted: "Notifies Finance/Admin when an AM submits an RFQ for approval",
    notif_desc_approved: "Notifies the AM when Finance approves their RFQ",
    notif_desc_returned: "Notifies the AM when Finance returns the RFQ for correction, with the reason",
    notif_desc_quot_sent: "Notifies the AM when the RFQ status changes to Quot Sent",
    notif_desc_rejected: "Notifies Admin/Finance (and the AM, if someone else rejected it) when an RFQ is rejected",
    notif_desc_invoiced: "Notifies the AM and Admin/Finance when the RFQ is marked as Invoiced",
    notif_desc_partially_paid: "Notifies the AM and Admin/Finance when the RFQ is marked as Partially Paid",
    notif_desc_paid: "Notifies the AM and Admin/Finance when the RFQ is marked as fully Paid",
    notif_desc_invoice_requested: "Notifies Admins when an AM requests an invoice for a Quot Sent RFQ",
    notif_desc_invoice_available: "Notifies the AM when the invoice PDF is uploaded and ready to download",
    notif_desc_quotation_available: "Notifies the AM when the quotation PDF is uploaded and ready to download",
    request_invoice_btn: "Request Invoice",
    invoice_requested_label: "Invoice Requested",
    invoice_requested_toast: "Invoice requested — admin has been notified",
    finance_no_saved: "Finance Quotation No saved",
    finance_quote_no_short: "Quot No",
    invoice: "Invoice",
    finance: "Finance",
    quot_no: "Quot No",
    by: "By",
    payment: "Payment",
    invoice_saved: "Invoice details saved",
    mark_as_paid_desc: "Mark this invoice as fully paid",
    disclaimer_label: "This is not a quotation and tax is not included",
    finance_team_only: "Finance team only",
    // New features
    canceled: "Canceled",
    cancel_rfq: "Cancel RFQ",
    cancel_confirm: "Are you sure you want to cancel this RFQ?",
    rfq_canceled: "RFQ canceled",
    return_message_label: "Return Reason",
    return_message_placeholder: "Explain why this RFQ is being returned...",
    return_reason: "Return Reason",
    returned_banner_title: "RFQ Returned for Correction",
    returned_banner_desc: "This RFQ has been returned. Please review the reason below and make the necessary corrections.",
    pdf_missing_banner_title: "Quotation PDF Not Uploaded",
    pdf_missing_banner_desc: "This RFQ is Quot Sent but the Quotation PDF hasn't been uploaded yet. Please upload it below.",
    invoice_missing_banner_title: "Invoice PDF Not Uploaded",
    invoice_missing_banner_desc: "This RFQ is Invoiced but the Invoice PDF hasn't been uploaded yet. Please upload it below.",
    pdf_alerts_title: "PDF Missing",
    no_pdf_alerts: "All caught up",
    notifications_title: "Notifications",
    no_notifications: "No notifications yet",
    mark_all_read: "Mark all read",
    time_ago_now: "now",
    time_ago_minutes: "{n}m",
    time_ago_hours: "{n}h",
    time_ago_days: "{n}d",
    notif_title_submitted: "Quotation Requested",
    notif_title_invoice_requested: "Invoice Requested",
    notif_title_approved: "RFQ Approved",
    notif_title_quotation_available: "Quotation Available",
    notif_title_invoice_available: "Invoice Available",
    notif_title_invoiced: "RFQ Invoiced",
    notif_title_returned: "RFQ Returned",
    notif_title_rejected: "RFQ Rejected",
    notif_title_quot_sent: "RFQ Quot Sent",
    notif_title_paid: "RFQ Paid",
    notif_title_partially_paid: "RFQ Partially Paid",
    notif_title_upload_quotation: "Upload Quotation",
    notif_title_upload_invoice: "Upload Invoice",
    reopen_rfq: "Reopen",
    reopen_confirm: "Reopening will revert this RFQ to Draft for editing and immediately remove any uploaded quotation/invoice files. Continue?",
    reject_confirm: "Are you sure you want to reject this RFQ?",
    reject_by_client_confirm: "Reject this RFQ? It will be noted as rejected by client / account manager.",
    rejected_by_client: "Rejected by Client / Account Manager",
    reject_modal_title: "Reject RFQ",
    reject_reason_label: "Rejection Reason",
    reject_reason_placeholder: "Why is this RFQ being rejected? e.g. Client declined, pricing issue...",
    reject_confirm_btn: "Reject RFQ",
    rfq_reopened: "RFQ reopened",
    change_status: "Change Status",
    refresh: "Refresh",
    margin_zero_error: "Margin cannot be negative",
    admin_status_override: "Admin Status Override",
    other_status: "Other Status",
    // Packages
    packages_tab: "Packages",
    add_package: "Add Package",
    edit_package: "Edit Package",
    save_package: "Save Package",
    pkg_name: "Package Name",
    pkg_name_placeholder: "e.g. Basic Setup Package",
    pkg_items: "Package Items",
    pkg_needs_items: "Package must have at least one item",
    pkg_created: "Package created",
    pkg_updated: "Package updated",
    pkg_deleted: "Package deleted",
    no_packages: "No packages yet",
    from_packages: "From Packages",
    select_package: "Select a package to insert all its items",
    workspace: "Workspace",
    insights: "Insights",
    system: "System",
    progress: "Progress",
    current: "Current",
    welcome: "Welcome",
    draft_banner: "You have draft RFQs",
    draft_banner_desc: "Finish and submit them so they move on to quotation.",
    review_drafts: "Review drafts",
    submitted_banner_title_one: "{n} RFQ submitted for review",
    submitted_banner_title_other: "{n} RFQs submitted for review",
    submitted_banner_desc: "Review and approve them to keep RFQs moving.",
    review_submitted: "Review",
    invoice_requested_banner_title_one: "{n} invoice requested",
    invoice_requested_banner_title_other: "{n} invoices requested",
    invoice_requested_banner_desc: "An Account Manager is waiting on these invoices.",
    review_invoice_requests: "Process",
    changes_saved: "Changes saved",
    brand_color: "Brand Color",
    top_clients: "Top Clients",
    monthly_rfqs: "Monthly RFQs",
    total_value: "Total Value",
    status_breakdown: "Status Breakdown",
    delegation_title: "Delegation",
    delegation_desc: "Delegate your RFQs to another team member when you are on leave. They will have full access to view, edit, and submit your RFQs.",
    select_delegate: "Select a team member...",
    delegate_btn: "Delegate",
    delegation_set: "Delegation set successfully",
    delegation_revoked: "Delegation revoked",
    currently_delegated: "Currently delegated",
    revoke: "Revoke",
    delegated_from: "This RFQ is delegated from",
    // Edit tracking
    edit_tracking_banner_title: "Changes Detected",
    edit_tracking_banner_desc: "This RFQ was edited after being returned. Changed fields are highlighted below.",
    item_edited: "Edited",
    item_added: "New",
    item_removed: "Removed",
    field_changed: "Changed",
    // Admin tabs - new
    notifications_tab: "Notifications",
    roles_tab: "Roles",
    general_tab: "General",
    items_and_packages: "Items",
    // Roles & Permissions
    roles_permissions: "Roles & Permissions",
    roles_subtitle: "Manage roles and assign permissions to each role",
    add_role: "Add Role",
    role_name: "Role Name",
    role_name_placeholder: "e.g. supervisor",
    role_label: "Display Label",
    role_label_placeholder: "e.g. Supervisor",
    create_role: "Create Role",
    edit_role: "Edit",
    save_role: "Save",
    delete_role: "Delete",
    role_created: "Role created",
    role_updated: "Role updated",
    role_deleted: "Role deleted",
    no_roles: "No roles",
    system_role: "System",
    custom_role: "Custom",
    permissions: "Permissions",
    cat_rfq_workflow: "RFQ Workflow & Approvals",
    cat_finance_profit: "Finance, Profit & Packages",
    cat_analytics: "Analytics & Intelligence",
    cat_system_access: "System, Catalog & Security",
    search_permissions: "Search permissions...",
    select_all: "Select all",
    deselect_all: "Deselect all",
    no_roles: "No roles yet",
    no_permissions_found: "No permissions match your search",
    delete_role_confirm: "Delete role",
    perm_view_rfqs: "View RFQs",
    perm_create_rfqs: "Create RFQs",
    perm_approve_rfqs: "Approve RFQs",
    perm_reject_rfqs: "Reject RFQs",
    perm_edit_finance_fields: "Edit Finance Fields",
    perm_view_admin_analytics: "Admin Analytics",
    perm_view_am_analytics: "AM Analytics",
    perm_manage_settings: "Manage Settings",
    perm_export_csv: "Export CSV",
    perm_delete_rfqs: "Delete RFQs",
    perm_view_profit: "View Profit",
    perm_view_online_users: "View Online Users",
    perm_use_delegation: "Use Delegation",
    perm_view_deleted_items: "View Deleted Items",
    perm_upload_attachments: "Upload Attachments",
    perm_view_attachments: "View Attachments (Quotation/Invoice PDFs)",
    perm_view_catalog: "View Catalog (From Catalog button)",
    perm_view_packages: "View Packages (From Packages button)",
    max_attachment_size: "Max Attachment Size",
    max_attachment_size_desc: "Maximum PDF file size for Quotation/Invoice attachments",
    storage_used: "Storage Used",
    storage_used_desc: "Total size of all uploaded PDF attachments",
    files: "files",
    import_rfqs: "Import RFQs",
    import_rfqs_desc: "Bulk import RFQs from a CSV file. Each RFQ gets a fresh auto-generated quote number.",
    download_template: "Download Template",
    choose_csv_file: "Choose CSV file...",
    import: "Import",
    import_success_msg: "Imported",
    successfully: "successfully",
    show_deleted_items: "Show Deleted Items",
    deleted_items_title: "Deleted Items",
    no_deleted_items: "No items have been deleted from this RFQ",
    deleted_by: "Deleted by",
    attachments_section: "Attachments",
    quotation_pdf: "Quotation PDF",
    invoice_pdf: "Invoice PDF",
    attachment_not_available_yet: "Not available yet",
    attachment_uploaded: "File uploaded",
    pdf_only_error: "Only PDF files are allowed",
    upload: "Upload",
    replace: "Replace",
    download: "Download",
    download_failed: "Download failed",
    view_failed: "Failed to open file",
    quotation_available_msg: "Quotation Available for download",
    invoice_available_msg: "Invoice Available for download",
    view: "View",
    item_profit: "Profit",
    security_tab: "Security",
    activity_tab: "Activity",
    audit_log_tab: "Audit Log",
    search_events: "Search events...",
    events: "events",
    actor: "Actor",
    level: "Level",
    rfq: "RFQ",
    page: "Page",
    watermark_settings: "Watermark",
    watermark_enable: "Show username watermark on RFQs",
    watermark_desc: "Displays the logged-in user's name as a diagonal watermark on every quotation form",
    no_activity: "No recent activity",
    my_rfqs: "My RFQs",
    my_revenue: "My Revenue",
    my_revenue_trend: "My Invoiced Revenue",
    approval_rate: "Approval Rate",
    status_breakdown: "Status Breakdown",
    my_top_clients: "My Top Clients",
    revenue: "Revenue",
    top_am_sales: "Top AM Sales",
    top_am_profit: "Top AM Profit",
    top_client_sales: "Top Client Sales",
    top_client_profit: "Top Client Profit",
    kick_user: "Kick Out",
    kick_confirm: "Force logout this user? Their session will be terminated immediately.",
    user_kicked: "User has been kicked out",
    active: "Active",
    active_members: "Active Members",
    you: "You",
    online: "Online",
    no_other_users_online: "No one else online",
    maintenance_mode: "Maintenance Mode",
    maintenance_mode_desc: "Block all non-admin users from accessing the system",
    maintenance_title: "System Maintenance",
    maintenance_message: "The system is currently under maintenance. Please try again later.",
    maintenance_admin_banner: "Maintenance mode is ON — only you can see the full app",
    disable_maintenance: "Turn Off Maintenance",
    maintenance_disabled: "Maintenance mode turned off",
    maintenance_disable_failed: "Failed to disable maintenance mode",
    admin_edit_mode: "Admin Edit Mode",
    admin_edit_mode_desc: "Allow admin to edit any RFQ regardless of status (paid, invoiced, etc.)",
    admin_edit_total_confirm: "The total amount will change from the original",
    old_total: "Old total",
    new_total: "New total",
    confirm_proceed: "Proceed with this change?",
    clear_filter: "Clear All",
    custom_filter: "Custom Filter",
    show_all: "Show All",
  },
  ar: {
    app_name: "RFQ Hub",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    signing_in: "جارٍ تسجيل الدخول...",
    sign_in: "تسجيل الدخول",
    sign_in_google: "تسجيل الدخول بحساب Google",
    or: "أو",
    verifying_connection: "جارٍ التحقق من اتصالك...",
    security_check: "فحص أمني بواسطة Cloudflare",
    verification_failed: "فشل التحقق",
    please_try_again: "يرجى المحاولة مرة أخرى",
    try_again: "إعادة المحاولة",
    locked: "مقفل",
    unlock_account: "فتح الحساب",
    account_unlocked: "تم فتح الحساب",
    hi: "مرحبًا",
    different_user: "مستخدم آخر",
    passkeys: "مفاتيح المرور",
    add_passkey: "إضافة مفتاح مرور",
    passkey_desc: "استخدم البصمة أو التعرف على الوجه أو مفتاح الأمان لتسجيل الدخول بدون كلمة مرور.",
    no_passkeys: "لا توجد مفاتيح مرور مسجلة",
    passkey_added: "تمت إضافة مفتاح المرور بنجاح",
    passkey_deleted: "تم حذف مفتاح المرور",
    passkey_cancelled: "تم إلغاء المصادقة",
    sign_in_passkey: "تسجيل الدخول بمفتاح المرور",
    added: "أُضيف",
    default_credentials: "admin@rfq.inception.sa / Admin@123",
    // Forgot/Reset password
    forgot_password: "نسيت كلمة المرور؟",
    forgot_password_desc: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
    send_reset_link: "إرسال رابط إعادة التعيين",
    reset_email_sent: "إذا كان البريد مسجلاً، تم إرسال رابط إعادة التعيين. تحقق من بريدك.",
    back_to_login: "العودة لتسجيل الدخول",
    reset_password: "إعادة تعيين كلمة المرور",
    reset_password_desc: "اختر كلمة مرور جديدة لحسابك.",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    passwords_mismatch: "كلمات المرور غير متطابقة",
    password_too_short: "كلمة المرور يجب أن تكون 4 أحرف على الأقل",
    password_reset_success: "تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول.",
    // Invite
    accept_invite: "قبول الدعوة",
    accept_invite_desc: "قم بتعيين كلمة مرور لإنشاء حسابك.",
    create_account: "إنشاء الحساب",
    account_created: "تم إنشاء الحساب بنجاح. يمكنك الآن تسجيل الدخول.",
    click_here_to_login: "اضغط هنا لتسجيل الدخول",
    invite_user: "دعوة مستخدم",
    invite_email: "البريد الإلكتروني",
    invite_name: "الاسم الكامل",
    invite_role: "الدور",
    invite_sent: "تم إرسال الدعوة",
    invite_sending: "جاري الإرسال...",
    finance_manager_role: "مدير مالي",
    edit_user: "تعديل",
    save_changes: "حفظ",
    user_updated: "تم تحديث المستخدم",
    active: "نشط",
    inactive: "معطل",
    deactivated_account: "هذا الحساب معطل",
    tab_personal_info: "المعلومات الشخصية",
    tab_security: "الأمان",
    tab_delegation: "التفويض",
    tab_passkeys: "مفاتيح الدخول",
    change_photo: "تغيير الصورة",
    remove_photo: "إزالة الصورة",
    avatar_specs: "بحد أقصى 5 ميجابايت · JPEG أو PNG أو WEBP",
    avatar_invalid_type: "يُسمح فقط بصور JPEG أو PNG أو WEBP",
    avatar_too_large: "يجب أن تكون الصورة أقل من 5 ميجابايت",
    avatar_uploaded: "تم تحديث الصورة الشخصية",
    avatar_removed: "تمت إزالة الصورة الشخصية",
    admin_only: "للمسؤول فقط",
    session_expired: "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى.",
    session_timeout: "تسجيل الخروج التلقائي",
    dark_mode: "الوضع الداكن",
    light_mode: "الوضع الفاتح",
    auto_mode: "تلقائي",
    theme_mode: "وضع المظهر",
    this_month: "هذا الشهر",
    total_rfqs: "إجمالي الطلبات",
    company_analytics: "تحليلات الشركة",
    analytics: "التحليلات",
    revenue_financial: "الإيرادات والمالية",
    total_revenue: "إجمالي الإيرادات",
    paid_revenue: "الإيرادات المدفوعة",
    total_profit: "إجمالي الأرباح",
    avg_deal_size: "متوسط حجم الصفقة",
    profit_margin: "هامش الربح",
    revenue_over_time: "الإيرادات عبر الزمن",
    top_clients_revenue: "أعلى العملاء حسب الإيرادات",
    top_am_revenue: "أعلى مديري الحسابات حسب الإيرادات",
    profit_by_am: "الأرباح حسب مدير الحساب",
    profit_by_client: "الأرباح حسب العميل",
    avg_deal_trend: "اتجاه متوسط حجم الصفقة",
    overview: "نظرة عامة",
    by_client: "حسب العميل",
    by_am: "حسب مدير الحساب",
    deal_size: "حجم الصفقة",
    rfq_pipeline: "مسار طلبات الأسعار",
    status_distribution: "التوزيع",
    conversion_funnel: "القمع",
    monthly_volume: "الحجم",
    time_to_close: "التوقيت",
    avg_time_close: "متوسط وقت الإغلاق",
    days_created_to_quot_sent: "أيام من الإنشاء إلى إرسال العرض",
    close_time_trend: "اتجاه وقت الإغلاق (أيام)",
    am_performance: "أداء مديري الحسابات",
    rfqs_per_am: "طلبات الأسعار لكل مدير حساب",
    am_win_rate: "نسبة الفوز",
    rfqs_count: "الطلبات",
    win_rate: "نسبة الفوز",
    approved_vs_rejected: "الموافق عليها مقابل المرفوضة",
    am_ranking: "ترتيب مديري الحسابات",
    revenue_by_am: "الإيرادات والأرباح حسب مدير الحساب",
    am_revenue_ranking: "ترتيب الإيرادات",
    client_insights: "تحليلات العملاء",
    total_clients: "إجمالي العملاء",
    repeat_clients: "العملاء المتكررون",
    new_clients: "العملاء الجدد",
    repeat_rate: "نسبة التكرار",
    single_rfq: "طلب واحد",
    top_clients_volume: "أعلى العملاء حسب الحجم",
    by_revenue: "حسب الإيرادات",
    by_volume: "حسب الحجم",
    client_revenue_chart: "إيرادات العملاء",
    client_volume_chart: "حجم العملاء",
    full_ranking: "الترتيب الكامل",
    health_score: "الصحة",
    health_excellent: "ممتاز",
    health_good: "جيد",
    health_fair: "مقبول",
    health_at_risk: "معرض للخطر",
    rfqs_short: "الطلبات",
    avg_pay: "متوسط الدفع",
    avg_pay_days: "متوسط الدفع",
    score: "النقاط",
    repeat: "التكرار",
    payment: "الدفع",
    trend: "الاتجاه",
    client: "العميل",
    rfqs_in_period: "طلبات في الفترة",
    margin: "هامش",
    all_created: "المُنشأة",
    invoiced_revenue: "إيرادات الفواتير",
    top_clients: "أفضل العملاء",
    top_ams: "أفضل مديري الحسابات",
    recent_activity: "النشاط الأخير",
    export_csv: "تصدير CSV",
    total_cost: "التكلفة",
    profit: "الربح",
    session_timeout_desc: "تسجيل خروج المستخدمين بعد عدم النشاط لمدة",
    am_analytics: "تحليلات مدير الحساب",
    am_analytics_desc: "عرض بطاقات التحليلات على لوحة مدير الحساب",
    email_notifications: "إشعارات البريد الإلكتروني",
    email_notifications_desc: "التحكم الرئيسي في جميع إشعارات البريد الإلكتروني",
    notify_per_status: "إشعار حسب الحالة",
    new_quotation: "طلب عرض سعر جديد",
    quotations: "طلبات عروض الأسعار",
    admin: "الإعدادات",
    sign_out: "تسجيل الخروج",
    dashboard_title: "طلبات عروض الأسعار",
    dashboard_subtitle: "إدارة طلبات عروض أسعارك",
    total: "الكل",
    draft: "مسودة",
    submitted: "مُقدَّم",
    resubmitted: "مُعاد تقديمه",
    approved: "مُعتمَد",
    quot_sent: "تم إرسال العرض",
    progress_finalized: "مغلق",
    submitted_by: "مقدم من",
    rejected: "مرفوض",
    returned: "مُعاد للتصحيح",
    reject_confirm: "هل أنت متأكد من رفض هذا الطلب؟",
    reject_by_client_confirm: "رفض هذا الطلب؟ سيتم تدوين أنه مرفوض من قبل العميل / مدير الحساب.",
    rejected_by_client: "مرفوض من قبل العميل / مدير الحساب",
    reject_modal_title: "رفض الطلب",
    reject_reason_label: "سبب الرفض",
    reject_reason_placeholder: "لماذا يتم رفض هذا الطلب؟ مثلاً: رفض العميل، مشكلة في التسعير...",
    reject_confirm_btn: "رفض الطلب",
    cancel_modal_title: "إلغاء الطلب",
    cancel_reason_label: "سبب الإلغاء",
    cancel_reason_placeholder: "لماذا يتم إلغاء هذا الطلب؟ مثال: طلب العميل، إدخال مكرر...",
    cancel_confirm_btn: "إلغاء الطلب",
    archived: "مؤرشف",
    all: "الكل",
    search_placeholder: "ابحث عن أي شيء...",
    date_filter: "التاريخ",
    date_all: "كل الأوقات",
    date_today: "اليوم",
    date_7days: "آخر 7 أيام",
    date_30days: "آخر 30 يوم",
    date_3months: "آخر 3 أشهر",
    quote_number: "رقم الطلب",
    client: "العميل",
    project: "المشروع",
    status: "الحالة",
    amount: "المبلغ",
    empty_state: "لا توجد طلبات عروض أسعار",
    create_first: "أنشئ أول طلب عرض سعر",
    new_quotation_title: "طلب عرض سعر جديد",
    quotation_details: "تفاصيل طلب عرض السعر",
    client_name: "اسم العميل",
    client_placeholder: "شركة أو اسم العميل",
    create_new_client: "إنشاء عميل جديد",
    no_clients_yet: "لا يوجد عملاء بعد — اكتب اسمًا لإنشاء عميل جديد",
    project_name: "اسم المشروع",
    project_placeholder: "وصف المشروع",
    items_section: "البنود",
    item_details: "تفاصيل البند",
    new_item: "بند جديد",
    item_name: "اسم البند",
    item_placeholder: "مثال: خدمات تصميم المواقع",
    description: "الوصف",
    desc_placeholder: "تفاصيل اختيارية...",
    qty: "الكمية",
    selling_price_sar: "سعر البيع (ريال)",
    third_party: "مورد خارجي",
    supplier_cost: "تكلفة المورد (ريال)",
    margin_pct: "هامش الربح %",
    calc_price: "السعر المحسوب (ريال)",
    override_price: "تعديل السعر",
    override_price_sar: "سعر البيع المعدَّل (ريال)",
    line_total: "إجمالي البند",
    item_total: "إجمالي البند",
    add_item_btn: "إضافة البند",
    cancel: "إلغاء",
    send: "إرسال",
    add_more: "إضافة بند آخر",
    no_items_yet: "لا توجد بنود بعد.",
    no_items: "لا توجد بنود",
    notes_label: "ملاحظات",
    notes_placeholder: "أي ملاحظات أو شروط إضافية...",
    subtotal_excl_vat: "الإجمالي غير شامل ضريبة القيمة المضافة",
    save_draft: "حفظ كمسودة",
    submit_review: "تقديم للمالية",
    export_pdf: "تصدير PDF",
    back: "رجوع",
    pending_review_title: "في انتظار موافقة المدير",
    pending_review_desc: "تم تقديم هذا الطلب وهو قيد المراجعة من قِبَل المدير.",
    review_quotation: "مراجعة فريق المالية:",
    approve: "اعتماد",
    reject: "إعادة",
    edit_quotation: "تعديل الطلب",
    edit_warning: "سيعيد التعديل هذا الطلب إلى حالة المسودة.",
    admin_panel: "الإعدادات",
    admin_subtitle: "إدارة المستخدمين والعناصر والأدوار وإعدادات التطبيق",
    users_tab: "المستخدمون",
    settings_tab: "الإعدادات",
    add_user: "إضافة مستخدم",
    create_user_title: "إنشاء مستخدم جديد",
    name: "الاسم",
    name_placeholder: "الاسم الكامل",
    email_placeholder: "email@example.com",
    password_placeholder: "كلمة المرور",
    role: "الدور",
    account_manager_role: "مدير حساب",
    admin_role: "مدير",
    create_user_btn: "إنشاء المستخدم",
    no_users: "لا يوجد مستخدمون",
    delete: "حذف",
    delete_rfq: "حذف",
    delete_confirm: "هل أنت متأكد من حذف هذا الطلب؟",
    rfq_deleted: "تم حذف الطلب",
    archive: "أرشفة",
    archive_confirm: "أرشفة هذا الطلب المرفوض؟",
    rfq_archived: "تم أرشفة الطلب",
    quotation_settings: "إعدادات الطلبات",
    default_margin: "هامش الربح الافتراضي %",
    default_margin_desc: "يُطبَّق على بنود المورد الجديدة بشكل افتراضي",
    allow_override: "السماح بتعديل سعر البيع",
    allow_override_desc: "يمكن لمديري الحسابات تعديل السعر المحسوب لبنود الموردين",
    change_password_title: "تغيير كلمة مرور المستخدم",
    select_user: "اختر مستخدماً...",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    change_password_btn: "تغيير كلمة المرور",
    passwords_no_match: "كلمتا المرور غير متطابقتين",
    supplier_label: "المورد",
    third_party_label: "طرف ثالث",
    supplier_cost_label: "التكلفة",
    quotation_saved: "تم حفظ الطلب",
    quotation_updated: "تم تحديث الطلب",
    status_updated: "تم تحديث الحالة",
    user_created: "تم إنشاء المستخدم بنجاح",
    user_deleted: "تم حذف المستخدم",
    settings_saved: "تم حفظ الإعدادات",
    password_changed: "تم تغيير كلمة المرور بنجاح",
    client_required: "اسم العميل مطلوب",
    project_required: "اسم المشروع مطلوب",
    item_name_required: "اسم البند مطلوب",
    qty_required: "الكمية يجب أن تكون أكبر من صفر",
    price_required: "مطلوب",
    all_fields_required: "جميع الحقول مطلوبة",
    invalid_role: "دور غير صالح",
    issue_date: "تاريخ الإصدار",
    profile: "الملف الشخصي",
    profile_title: "ملفي الشخصي",
    profile_subtitle: "إدارة إعدادات حسابك",
    profile_saved: "تم حفظ الملف الشخصي",
    mobile: "الجوال",
    mobile_placeholder: "+966 5x xxx xxxx",
    profile_picture: "صورة الملف الشخصي",
    profile_picture_placeholder: "الصق رابط الصورة",
    admin_only: "المسؤول فقط",
    badge_color: "لون الشارة",
    reset: "إعادة تعيين",
    change_my_password: "تغيير كلمة المرور",
    current_password: "كلمة المرور الحالية",
    password_min_length: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    duplicate_quotation: "نسخ",
    quotation_duplicated: "تم نسخ الطلب",
    generating_pdf: "جارٍ إنشاء PDF...",
    services_tab: "الخدمات",
    add_service: "إضافة خدمة",
    edit_service: "تعديل الخدمة",
    service_name: "اسم الخدمة",
    service_name_placeholder: "مثال: تصميم مواقع",
    service_description: "الوصف",
    service_desc_placeholder: "تفاصيل الخدمة...",
    service_price: "السعر الافتراضي (ريال)",
    save_service: "حفظ",
    no_services: "لا توجد خدمات بعد",
    service_created: "تم إنشاء الخدمة",
    service_updated: "تم تحديث الخدمة",
    service_deleted: "تم حذف الخدمة",
    item_type: "نوع العنصر",
    item_type_internal: "داخلي",
    item_type_third_party: "طرف ثالث",
    supplier_price_label: "سعر المورد (ريال)",
    margin_label: "هامش الربح %",
    final_price_label: "السعر النهائي (ريال)",
    click_to_edit: "انقر للتعديل",
    hide_statuses: "تصفية مخصصة",
    reassign_rfqs: "إعادة تعيين الطلبات",
    reassign_desc: "نقل جميع الطلبات من هذا المستخدم إلى مستخدم آخر.",
    reassign_before_action: "اختر مستخدمًا لنقل جميع الطلبات قبل المتابعة.",
    move_rfqs_to: "نقل الطلبات إلى",
    select_user: "اختر مستخدم...",
    skip_reassign: "تخطي (بدون نقل)",
    reassign: "إعادة تعيين",
    move_and_delete: "نقل وحذف",
    move_and_deactivate: "نقل وتعطيل",
    rfqs_reassigned: "تم إعادة تعيين الطلبات بنجاح",
    moved_from: "منقول من",
    delete_user_title: "حذف المستخدم",
    deactivate_user_title: "تعطيل المستخدم",
    vendor_party_price: "سعر الطرف الثالث/المورد",
    our_final_price: "سعرنا النهائي (انقر للتعديل)",
    auto: "تلقائي",
    select_item_type: "اختر نوع العنصر للإضافة",
    internal_desc: "خدمة أو منتج داخلي",
    third_party_desc: "من مورد خارجي",
    select_from_catalog: "من الكتالوج",
    revision_history: "سجل التعديلات",
    no_history: "لا يوجد سجل تعديلات",
    history_by: "بواسطة",
    trash: "المحذوفات",
    trash_title: "المحذوفات",
    trash_subtitle: "الطلبات المحذوفة",
    restore: "استعادة",
    rfq_restored: "تم استعادة الطلب",
    delete_permanent: "حذف نهائي",
    delete_permanent_confirm: "حذف هذا الطلب نهائياً؟ لا يمكن التراجع.",
    rfq_permanently_deleted: "تم الحذف نهائياً",
    empty_trash: "سلة المحذوفات فارغة",
    // Clients
    clients: "العملاء",
    clients_subtitle: "إدارة دليل العملاء",
    clients_lower: "عملاء",
    add_client: "إضافة عميل",
    edit_client: "تعديل العميل",
    client_name_label: "اسم العميل",
    legal_name: "الاسم القانوني",
    legal_name_placeholder: "الاسم القانوني الرسمي",
    no_clients: "لا يوجد عملاء بعد",
    client_saved: "تم حفظ العميل",
    client_deleted: "تم حذف العميل",
    // Finance
    finance_quote_no: "رقم العرض",
    finance_quote_no_placeholder: "أدخل رقم عرض السعر المالي",
    invoice_number: "رقم الفاتورة",
    invoice_number_placeholder: "أدخل رقم الفاتورة",
    invoice_status: "حالة الفاتورة",
    invoiced: "مفوتر",
    paid: "مدفوع",
    partially_paid: "مدفوع جزئياً",
    mark_as_paid: "تحديد كمدفوع",
    full_paid: "مدفوع بالكامل",
    not_invoiced: "غير مفوتر",
    notif_invoice_requested: "تم طلب الفاتورة",
    notif_invoice_available: "الفاتورة متاحة",
    notif_quotation_available: "عرض السعر متاح",
    notif_desc_submitted: "يُشعر المالية/الإدارة عند إرسال مدير الحساب طلب تسعير للموافقة",
    notif_desc_approved: "يُشعر مدير الحساب عند موافقة المالية على طلب التسعير",
    notif_desc_returned: "يُشعر مدير الحساب عند إعادة المالية الطلب للتصحيح مع ذكر السبب",
    notif_desc_quot_sent: "يُشعر مدير الحساب عند تغيير حالة الطلب إلى 'تم إرسال العرض'",
    notif_desc_rejected: "يُشعر المالية/الإدارة (ومدير الحساب إذا رفضه شخص آخر) عند رفض الطلب",
    notif_desc_invoiced: "يُشعر مدير الحساب والمالية/الإدارة عند تحديد الطلب كـ 'مفوتر'",
    notif_desc_partially_paid: "يُشعر مدير الحساب والمالية/الإدارة عند تحديد الطلب كـ 'مدفوع جزئياً'",
    notif_desc_paid: "يُشعر مدير الحساب والمالية/الإدارة عند تحديد الطلب كـ 'مدفوع' بالكامل",
    notif_desc_invoice_requested: "يُشعر الإدارة عند طلب مدير الحساب فاتورة لطلب تم إرسال عرضه",
    notif_desc_invoice_available: "يُشعر مدير الحساب عند رفع ملف الفاتورة وجاهزيته للتحميل",
    notif_desc_quotation_available: "يُشعر مدير الحساب عند رفع ملف عرض السعر وجاهزيته للتحميل",
    request_invoice_btn: "طلب الفاتورة",
    invoice_requested_label: "تم طلب الفاتورة",
    invoice_requested_toast: "تم طلب الفاتورة — تم إبلاغ المسؤول",
    finance_no_saved: "تم حفظ رقم عرض السعر المالي",
    finance_quote_no_short: "رقم العرض",
    invoice: "الفاتورة",
    finance: "المالية",
    quot_no: "رقم العرض",
    by: "بواسطة",
    payment: "الدفع",
    invoice_saved: "تم حفظ تفاصيل الفاتورة",
    mark_as_paid_desc: "وضع علامة على هذه الفاتورة كمدفوعة بالكامل",
    disclaimer_label: "هذا ليس عرض سعر والضريبة غير مشمولة",
    finance_team_only: "فريق المالية فقط",
    // New features
    canceled: "ملغي",
    cancel_rfq: "إلغاء الطلب",
    cancel_confirm: "هل أنت متأكد من إلغاء هذا الطلب؟",
    rfq_canceled: "تم إلغاء الطلب",
    return_message_label: "سبب الإرجاع",
    return_message_placeholder: "اشرح سبب إعادة هذا الطلب...",
    return_reason: "سبب الإرجاع",
    returned_banner_title: "تم إعادة الطلب للتصحيح",
    returned_banner_desc: "تم إعادة هذا الطلب. يرجى مراجعة السبب أدناه وإجراء التصحيحات اللازمة.",
    pdf_missing_banner_title: "لم يتم رفع عرض السعر PDF",
    pdf_missing_banner_desc: "تم إرسال هذا الطلب لكن لم يتم رفع ملف عرض السعر PDF بعد. يرجى رفعه أدناه.",
    invoice_missing_banner_title: "لم يتم رفع الفاتورة PDF",
    invoice_missing_banner_desc: "تم تحويل هذا الطلب إلى مفوتر لكن لم يتم رفع ملف الفاتورة PDF بعد. يرجى رفعه أدناه.",
    pdf_alerts_title: "ملفات PDF غير مرفوعة",
    no_pdf_alerts: "لا توجد تنبيهات",
    notifications_title: "الإشعارات",
    no_notifications: "لا توجد إشعارات بعد",
    mark_all_read: "تحديد الكل كمقروء",
    time_ago_now: "الآن",
    time_ago_minutes: "منذ {n} د",
    time_ago_hours: "منذ {n} س",
    time_ago_days: "منذ {n} ي",
    notif_title_submitted: "طلب عرض سعر",
    notif_title_invoice_requested: "تم طلب الفاتورة",
    notif_title_approved: "تمت الموافقة على الطلب",
    notif_title_quotation_available: "عرض السعر متاح",
    notif_title_invoice_available: "الفاتورة متاحة",
    notif_title_invoiced: "تمت فوترة الطلب",
    notif_title_returned: "تمت إعادة الطلب للتصحيح",
    notif_title_rejected: "تم رفض الطلب",
    notif_title_quot_sent: "تم إرسال العرض",
    notif_title_paid: "تم دفع الطلب",
    notif_title_partially_paid: "تم دفع الطلب جزئياً",
    notif_title_upload_quotation: "رفع عرض السعر",
    notif_title_upload_invoice: "رفع الفاتورة",
    reopen_rfq: "إعادة فتح",
    reopen_confirm: "ستتم إعادة فتح الطلب وإعادته إلى مسودة للتعديل، مع حذف أي ملفات عرض سعر أو فاتورة مرفوعة فوراً. هل تريد المتابعة؟",
    reject_confirm: "هل أنت متأكد من رفض هذا الطلب؟",
    reject_by_client_confirm: "رفض هذا الطلب؟ سيتم تدوين أنه مرفوض من قبل العميل / مدير الحساب.",
    rejected_by_client: "مرفوض من قبل العميل / مدير الحساب",
    reject_modal_title: "رفض الطلب",
    reject_reason_label: "سبب الرفض",
    reject_reason_placeholder: "لماذا يتم رفض هذا الطلب؟ مثلاً: رفض العميل، مشكلة في التسعير...",
    reject_confirm_btn: "رفض الطلب",
    rfq_reopened: "تم إعادة فتح الطلب",
    change_status: "تغيير الحالة",
    refresh: "تحديث",
    margin_zero_error: "لا يمكن أن يكون الهامش سالباً",
    admin_status_override: "تجاوز حالة المدير",
    other_status: "حالة أخرى",
    // Packages
    packages_tab: "الباقات",
    add_package: "إضافة باقة",
    edit_package: "تعديل الباقة",
    save_package: "حفظ الباقة",
    pkg_name: "اسم الباقة",
    pkg_name_placeholder: "مثال: باقة التأسيس",
    pkg_items: "عناصر الباقة",
    pkg_needs_items: "يجب أن تحتوي الباقة على عنصر واحد على الأقل",
    pkg_created: "تم إنشاء الباقة",
    pkg_updated: "تم تحديث الباقة",
    pkg_deleted: "تم حذف الباقة",
    no_packages: "لا توجد باقات بعد",
    from_packages: "من الباقات",
    select_package: "اختر باقة لإدراج جميع عناصرها",
    workspace: "مساحة العمل",
    insights: "التحليلات",
    system: "النظام",
    progress: "الحالة",
    current: "الحالي",
    welcome: "مرحبا",
    draft_banner: "لديك طلبات مسودة",
    draft_banner_desc: "أكملها وأرسلها لمتابعة تسعير العرض.",
    review_drafts: "مراجعة المسودات",
    submitted_banner_title_one: "طلب واحد مُرسل للمراجعة",
    submitted_banner_title_other: "{n} طلبات مُرسلة للمراجعة",
    submitted_banner_desc: "راجعها ووافق عليها لمتابعة سير العمل.",
    review_submitted: "مراجعة",
    invoice_requested_banner_title_one: "فاتورة واحدة مطلوبة",
    invoice_requested_banner_title_other: "{n} فواتير مطلوبة",
    invoice_requested_banner_desc: "مدير الحساب بانتظار هذه الفواتير.",
    review_invoice_requests: "معالجة",
    changes_saved: "تم حفظ التغييرات",
    brand_color: "لون العلامة",
    top_clients: "أبرز العملاء",
    monthly_rfqs: "الطلبات الشهرية",
    total_value: "القيمة الإجمالية",
    status_breakdown: "توزيع الحالات",
    delegation_title: "التفويض",
    delegation_desc: "فوّض طلباتك لعضو آخر في الفريق عند غيابك. سيحصل على صلاحية كاملة للعرض والتعديل والإرسال.",
    select_delegate: "اختر عضو فريق...",
    delegate_btn: "تفويض",
    delegation_set: "تم التفويض بنجاح",
    delegation_revoked: "تم إلغاء التفويض",
    currently_delegated: "مفوّض حالياً",
    revoke: "إلغاء",
    delegated_from: "هذا الطلب مفوّض من",
    // Edit tracking
    edit_tracking_banner_title: "تم اكتشاف تغييرات",
    edit_tracking_banner_desc: "تم تعديل هذا الطلب بعد إعادته. الحقول المعدّلة مُبرزة أدناه.",
    item_edited: "معدّل",
    item_added: "جديد",
    item_removed: "محذوف",
    field_changed: "تغيّر",
    // Admin tabs - new
    notifications_tab: "الإشعارات",
    roles_tab: "الأدوار",
    general_tab: "عام",
    items_and_packages: "العناصر",
    // Roles & Permissions
    roles_permissions: "الأدوار والصلاحيات",
    roles_subtitle: "إدارة الأدوار وتعيين الصلاحيات لكل دور",
    add_role: "إضافة دور",
    role_name: "اسم الدور",
    role_name_placeholder: "مثال: مشرف",
    role_label: "العنوان",
    role_label_placeholder: "مثال: مشرف",
    create_role: "إنشاء دور",
    edit_role: "تعديل",
    save_role: "حفظ",
    delete_role: "حذف",
    role_created: "تم إنشاء الدور",
    role_updated: "تم تحديث الدور",
    role_deleted: "تم حذف الدور",
    no_roles: "لا توجد أدوار",
    system_role: "نظام",
    custom_role: "مخصص",
    permissions: "الصلاحيات",
    cat_rfq_workflow: "سير عمل الطلبات والموافقات",
    cat_finance_profit: "المالية والأرباح والباقات",
    cat_analytics: "التحليلات والذكاء",
    cat_system_access: "النظام، الكتالوج والأمان",
    search_permissions: "بحث عن صلاحية...",
    select_all: "تحديد الكل",
    deselect_all: "إلغاء تحديد الكل",
    no_roles: "لا توجد أدوار بعد",
    no_permissions_found: "لا توجد صلاحيات مطابقة لبحثك",
    delete_role_confirm: "حذف الدور",
    perm_view_rfqs: "عرض الطلبات",
    perm_create_rfqs: "إنشاء طلبات",
    perm_approve_rfqs: "الموافقة على الطلبات",
    perm_reject_rfqs: "رفض الطلبات",
    perm_edit_finance_fields: "تعديل الحقول المالية",
    perm_view_admin_analytics: "تحليلات الإدارة",
    perm_view_am_analytics: "تحليلات مدير الحساب",
    perm_manage_settings: "إدارة الإعدادات",
    perm_export_csv: "تصدير CSV",
    perm_delete_rfqs: "حذف الطلبات",
    perm_view_profit: "عرض الأرباح",
    perm_view_online_users: "عرض المتصلين الآن",
    perm_use_delegation: "استخدام التفويض",
    perm_view_deleted_items: "عرض العناصر المحذوفة",
    perm_upload_attachments: "رفع المرفقات",
    perm_view_attachments: "عرض المرفقات (ملفات PDF للعرض/الفاتورة)",
    perm_view_catalog: "عرض الكتالوج (زر من الكتالوج)",
    perm_view_packages: "عرض الباقات (زر من الباقات)",
    max_attachment_size: "الحد الأقصى لحجم المرفق",
    max_attachment_size_desc: "الحد الأقصى لحجم ملف PDF لمرفقات العرض/الفاتورة",
    storage_used: "التخزين المستخدم",
    storage_used_desc: "الحجم الإجمالي لجميع ملفات PDF المرفوعة",
    files: "ملفات",
    import_rfqs: "استيراد طلبات عرض السعر",
    import_rfqs_desc: "استيراد طلبات عرض السعر بشكل مجمع من ملف CSV. يحصل كل طلب على رقم جديد تلقائياً.",
    download_template: "تحميل النموذج",
    choose_csv_file: "اختر ملف CSV...",
    import: "استيراد",
    import_success_msg: "تم استيراد",
    successfully: "بنجاح",
    show_deleted_items: "عرض العناصر المحذوفة",
    deleted_items_title: "العناصر المحذوفة",
    no_deleted_items: "لم يتم حذف أي عناصر من هذا الطلب",
    deleted_by: "حذف بواسطة",
    attachments_section: "المرفقات",
    quotation_pdf: "ملف PDF للعرض",
    invoice_pdf: "ملف PDF للفاتورة",
    attachment_not_available_yet: "غير متاح حالياً",
    attachment_uploaded: "تم رفع الملف",
    pdf_only_error: "يُسمح فقط بملفات PDF",
    upload: "رفع",
    replace: "استبدال",
    download: "تنزيل",
    download_failed: "فشل التنزيل",
    view_failed: "فشل فتح الملف",
    quotation_available_msg: "عرض السعر متاح للتنزيل",
    invoice_available_msg: "الفاتورة متاحة للتنزيل",
    view: "عرض",
    item_profit: "الربح",
    security_tab: "الأمان",
    activity_tab: "النشاط",
    audit_log_tab: "سجل التدقيق",
    search_events: "البحث في الأحداث...",
    events: "أحداث",
    actor: "المنفذ",
    level: "المستوى",
    rfq: "طلب",
    page: "صفحة",
    watermark_settings: "العلامة المائية",
    watermark_enable: "إظهار علامة مائية باسم المستخدم على الطلبات",
    watermark_desc: "يعرض اسم المستخدم المسجل كعلامة مائية مائلة على كل نموذج عرض أسعار",
    no_activity: "لا يوجد نشاط حديث",
    my_rfqs: "طلباتي",
    my_revenue: "إيراداتي",
    my_revenue_trend: "إيرادات الفوترة",
    approval_rate: "نسبة القبول",
    status_breakdown: "توزيع الحالات",
    my_top_clients: "أفضل عملائي",
    revenue: "الإيرادات",
    top_am_sales: "أعلى مبيعات مديري الحسابات",
    top_am_profit: "أعلى أرباح مديري الحسابات",
    top_client_sales: "أعلى مبيعات العملاء",
    top_client_profit: "أعلى أرباح العملاء",
    kick_user: "طرد المستخدم",
    kick_confirm: "هل تريد إنهاء جلسة هذا المستخدم؟ سيتم إنهاء جلسته فوراً.",
    user_kicked: "تم طرد المستخدم",
    active: "نشط",
    active_members: "الأعضاء النشطون",
    you: "أنت",
    online: "متصل",
    no_other_users_online: "لا يوجد أحد آخر متصل",
    maintenance_mode: "وضع الصيانة",
    maintenance_mode_desc: "حظر جميع المستخدمين غير المسؤولين من الوصول إلى النظام",
    maintenance_title: "صيانة النظام",
    maintenance_message: "النظام قيد الصيانة حالياً. يرجى المحاولة لاحقاً.",
    maintenance_admin_banner: "وضع الصيانة مُفعّل — أنت فقط من يستطيع رؤية التطبيق بالكامل",
    disable_maintenance: "إيقاف وضع الصيانة",
    maintenance_disabled: "تم إيقاف وضع الصيانة",
    maintenance_disable_failed: "فشل إيقاف وضع الصيانة",
    admin_edit_mode: "وضع تعديل المسؤول",
    admin_edit_mode_desc: "السماح للمسؤول بتعديل أي طلب تسعير بغض النظر عن حالته",
    admin_edit_total_confirm: "سيتغير المبلغ الإجمالي عن الأصلي",
    old_total: "الإجمالي القديم",
    new_total: "الإجمالي الجديد",
    confirm_proceed: "هل تريد المتابعة بهذا التغيير؟",
    clear_filter: "مسح الكل",
    custom_filter: "تصفية مخصصة",
    show_all: "إظهار الكل",
  },
};
